var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-card-actions"},[_c('r-button',{attrs:{"icon":"focus-zone"},on:{"click":_vm.flyTo}},[_vm._v(" Найти на карте ")]),_c('attributes-editor',{attrs:{"id":_vm.id,"source_id":_vm.etranSourceId},on:{"updated":function($event){return _vm.$emit('updated')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }